import axiosInstance from "../instance/axiosInstance";

class HistoryApi {
  static async getHistory(page, searchQuery) {
    let url = `/history/list?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getHistoryDetail(archiveId, page, searchQuery) {
    let url = `/history/detail/${archiveId}?page=${page}`;
    // Append search filters if they exist
    if (searchQuery) {
      if (searchQuery.search_date) {
        url += `&search_date=${encodeURIComponent(searchQuery.search_date)}`;
      }
      if (searchQuery.search_name) {
        url += `&search_name=${encodeURIComponent(searchQuery.search_name)}`;
      }
      if (searchQuery.search_type && searchQuery.search_type !== "all") {
        url += `&search_type=${encodeURIComponent(searchQuery.search_type)}`;
      }
    }
    try {
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      return error;
    }
  }

  static async getArchiveDetail(archiveId) {
    try {
      const response = await axiosInstance.get(`history/archive/${archiveId}`);
      return response.data;
    } catch (error) {
      return error;
    }
  }
  static async createHistory(formData) {
    try {
      const response = await axiosInstance.post(`/history/create`, formData);
      return response.data;
    } catch (error) {
      return error;
    }
  }
}

export default HistoryApi;
